import { cn, Divider } from "@quortex/front-common"
import type { FC, ReactNode } from "react"
import PanelTD from "./PanelTD"

interface Props {
  name?: string
  aside?: ReactNode
  description?: ReactNode
  showDivider?: boolean
  "data-testid"?: string
}

const EndpointPanelTD: FC<Props> = ({
  name,
  aside,
  description,
  showDivider,
  "data-testid": dataTestId
}) => (
  <PanelTD>
    <div className="flex items-center justify-between gap-xs">
      <div className="break-all font-medium text-sm" data-testid={dataTestId}>
        {name}
      </div>
      {aside}
    </div>
    {description && (
      <>
        {showDivider && <Divider className="my-xs" />}
        <div className={cn("text-grey-600 text-sm", !showDivider && "mt-xs")}>{description}</div>
      </>
    )}
  </PanelTD>
)

export default EndpointPanelTD
